/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CookieAliases {
  CUSTOM_HTML_0 = 'custom-html-0',
  FETCH_0 = 'fetch-0',
  PANEL_0 = 'panel-0',
}
export { CookieAliases };
